import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueRouter from 'vue-router'
import store from '@/store'
import VueCookies from 'vue-cookies'
import * as Sentry from '@sentry/vue'
import SVGIcon from '@/components/SVGIcon'
import ScreenSizePlugin from '@/utils/ScreenSizePlugin'
import configuration from './configuration'
// Remove interceptor - using local server instead

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(VueCookies)
Vue.use(ScreenSizePlugin)
Vue.component('svg-icon', SVGIcon)

if (process.env.APP_ENV === 'production') {
  // Errors only: Bugsink (errors.trainerday.com) keeps no traces, and 100%
  // tracing would post every page view to it.
  Sentry.init({
    Vue,
    dsn: configuration.sentryUrl,
    // Browser extensions' own scripts (e.g. MetaMask's inpage.js failing to connect) — not ours
    denyUrls: [/^(chrome|moz|safari(-web)?)-extension:/]
  })
}
export default new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
